<template>
  <div v-loading="isLoading">
    <el-upload
        class="upload-demo"
        action="#"
        :http-request="customRequest"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :show-file-list="true"
        list-type="picture-card"
        :file-list="fileList"
        :multiple="multiple"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :accept="acceptTypes"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <el-dialog append-to-body :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {tencentCos} from "@/util/tencentCos";

export default {
  name: 'FileUploadV2',

  props: {
    multiple: {
      type: Boolean,
      default: false // 默认单文件上传
    },
    value: {
      type: Array,
      default: () => [] // 默认空数组
    },
    accept: {
      type: String,
      default: 'image/*' // 默认支持所有图片格式
    }
  },

  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: this.value, // 初始化 fileList 为 props 的值
      isLoading: false,
    }
  },

  computed: {
    acceptTypes() {
      return this.accept; // 使用 props 中传入的 accept 类型
    }
  },

  watch: {
    value: {
      handler(newValue) {
        this.fileList = newValue; // 监听 props 的变化，更新 fileList
      },
      immediate: true // 初始化时触发
    },
    fileList(newFileList) {
      this.$emit('input', newFileList); // 触发 input 事件以实现双向绑定
    }
  },

  methods: {
    customRequest({
                    file,
                    onSuccess,
                    onError
                  }) {
      const formData = new FormData();
      formData.append('file', file);

      this.isLoading = true;

      tencentCos.upload(file).then(fileUrl => {
        const uploadedFile = {
          name: file.name,
          url: fileUrl,
          status: 'success',
          response: fileUrl,
          uid: file.uid || Date.now(),
        };

        onSuccess(uploadedFile);
        this.fileList.push(uploadedFile); // 将文件添加到 fileList

        console.log("fileUrl = " + fileUrl);
      }).catch(error => {
        console.error(error);
        onError('图片上传失败');
      })
          .finally(() => {
            this.isLoading = false;
          })
      ;
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList; // 更新 fileList
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    handleChange(file, fileList) {
      console.log(file, fileList);
    },

    beforeUpload(file) {

      if (!this.multiple && this.fileList.length >= 1) {
        this.$message.warning('只能上传一个文件');
        return false;
      }

      const isImage = file.type.startsWith('image/'); // 检查文件类型
      if (!isImage) {
        this.$message.error('只能上传图片文件');
      }
      return isImage; // 返回 false 将阻止上传
    },
  }
}
</script>

<style scoped>
/* 可添加样式 */
</style>
